import { createBrowserRouter } from "react-router-dom";
import Number from "../view/form/section/Number";
import Loading from "../view/form/section/Loading";
import Qr from "../view/form/section/Qr";
import Faq from "../view/user/faq";
import DashBoard from "../view/user/dashboard";
import MultiStepForm from "../view/form/section/MultiStepForm";
import Login from "../view/user/login/Login";
import Otp from "../view/user/login/Otp";
import SaaS from "../view/form/faq/saas/Saas";
import PricingPlans from "../view/user/pricing";
import ECommerce from "../view/form/faq/ECommerce/ECommerce";
import Education from "../view/form/faq/Education/Education";
import HealthCare from "../view/form/faq/HealthCare/HealthCare";
import Software from "../view/form/faq/Software/Software";
import Startup from "../view/form/faq/Startup/Startup";
import Telecommunications from "../view/form/faq/Telecommunications/Telecommunications";
import Travel from "../view/form/faq/Travel/Travel";
import CallLogs from "../view/user/callLogs";
import ProtectedRoute from "./ProtectedRoute";
import Other from "../view/form/faq/Others/Other";
import BillDetails from "../view/user/billDetails/BillDetails";
import CheckOut from "../view/user/checkout";
import ChashfreeRes from "../view/user/checkout/ChashfreeRes";
import Profile from "../view/user/profile";
import OptionFaq from "../view/form/section/OptionFaq";
import SelectIndustryType from "../view/form/section/SelectIndustryType";
import ManualFaq from "../view/form/faq/ManualFaq/ManualFaq";
import AgentLogin from "../view/agent/login/Login";
import AgentDashBoard from "../view/agent/dashboard";
import AgentTickets from "../view/agent/tickets";
import TicketTable from "../view/tickets/index.js";
import SingleTicket from "../view/tickets/singleTicket/SingleTicket.js";
import GetStarted from "../view/campaign/login/GetStarted.js";
import CampaignOptionFaq from "../view/campaign/form/section/OptionFaq.js";
import CampaignSelectIndustryType from "../view/campaign/form/section/SelectIndustryType.js";
import CampaignManualFaq from "../view/campaign/form/faq/ManualFaq/ManualFaq.js";
import CampaignECommerce from "../view/campaign/form/faq/ECommerce/ECommerce.js";
import CampaignEducation from "../view/campaign/form/faq/Education/Education.js";
import CampaignHealthCare from "../view/campaign/form/faq/HealthCare/HealthCare.js";
import CampaignOther from "../view/campaign/form/faq/Others/Other.js";
import CampaignSaaS from "../view/campaign/form/faq/saas/Saas.js";
import CampaignSoftware from "../view/campaign/form/faq/Software/Software.js";
import CampaignStartup from "../view/campaign/form/faq/Startup/Startup.js";
import CampaignTelecommunications from "../view/campaign/form/faq/Telecommunications/Telecommunications.js";
import CampaignTravel from "../view/campaign/form/faq/Travel/Travel.js";
import CampaignNumber from "../view/campaign/form/section/Number.js";
import SIngleTicket from "../view/agent/tickets/singleTicket/SIngleTicket.js";
import SingleTicketCard from "../view/tickets/singleTicket/SingleTicketCard.js";
import ManualFaqByAi from "../view/form/faq/ManualFaqByAi/ManualFaqByAi.js";
import ShowFaqByAi from "../view/form/faq/ManualFaqByAi/addFaq/ShowFaqByAi.js";
import UserSIngleTicket from "../view/tickets/singleTicket/SingleTicket.js";
import AdminLogin from "../view/admin/login/Login.js";
import AdminLeads from "../view/admin/leads/index.js";
import SingleLead from "../view/admin/leads/SingleLead.jsx";
import IdPassLogin from "../view/user/login/IdPassLogin.js";
import Integrations from "../view/user/Integrations/index.js";
import JustTalkHero from "../view/landing/JustTalkHero.js";
import LandingPage from "../view/landing/index.js";
import Kanban from "../view/user/kanbanboard/index.js";
import CallType from "../view/form/section/CallType.js";
import NewLead from "../view/user/newLead/index.js";
import EditLeads from "../view/user/kanbanboard/leadManagementSystem/EditLeads.js";
import AllUsers from "../view/admin/users/index.js";
import AdminDashboard from "../view/admin/dashboard/index.js";
import Did from "../view/admin/did/index.js";
import DropOff from "../view/admin/dropOff/index.js";
import Revenue from "../view/admin/revenue/index.js";
import RevenueAnalytics from "../view/admin/revenue/RevenueAnalytics.jsx";
import EditUser from "../view/admin/leads/EditUser.jsx";
import TeamMember from "../view/admin/teamMember/index.js";
import NotFound from "../view/NotFound.js";
import Sla from "../view/user/reporting/sla/index.jsx";
import ConversionReport from "../view/user/reporting/conversion/index.jsx";
import CDRReport from "../view/user/reporting/cdr/index.jsx";
import TrafficReport from "../view/user/reporting/traffic/index.jsx";
import LeadCaptureForm from "../view/public/leadForm";
import BookingPage from "../view/booking/BookingPage";
import AppointmentBooking from "../view/appointment/AppointmentBooking";
import GoogleCallback from "../view/user/scheduler/GoogleCallback";
import OutlookCallback from "../view/user/scheduler/OutlookCallback";
import ScheduleSettings from "../view/user/scheduler/ScheduleSettings";
import MetaLeads from "../view/user/metaLeads/MetaLeads.jsx";
import TeamMembers from "../view/user/teamMembers/index.js";
import CalendarSettings from "../view/user/CalendarSettings.js";
import BuiltForYou from "../view/user/lake/BuiltForYou.jsx";
import DashboardV2 from "../view/user/dashboard/DashboardV2.js";
import CampaignSyncView from "../view/agent/campaignSync/index.js";
import AgentAttendance from "../view/agent/attendance/index.js";
import AdminAgents from "../view/admin/agents/index.js";
import CampaignMonitorView from "../view/agent/campaignMonitor/index.js";
import UnreachedLeadsReport from "../view/user/reporting/unreached/index.jsx";
import DetailsModule from "../view/admin/details/index.js";
import ClientLogsIndex from "../view/admin/details/ClientLogsIndex.js";
import HistoryModule from "../view/admin/history/index.js";
import SidebarSettings from "../view/admin/sidebarSettings/index.js";
import Complaints from "../view/user/complaints/index.js";
import ComplaintDetail from "../view/user/complaints/ComplaintDetail.js";
import ComplaintReports from "../view/user/complaints/ComplaintReports.js";
import ComplaintSettings from "../view/user/complaints/ComplaintSettings.js";
import HelpdeskInbox from "../view/helpdesk/TicketInbox.js";
import HelpdeskTicket from "../view/helpdesk/TicketDetail.js";
import HelpdeskChat from "../view/helpdesk/LiveChat.js";
import HelpdeskCustomer from "../view/helpdesk/CustomerProfile.js";
import HelpdeskKnowledge from "../view/helpdesk/KnowledgeBase.js";
import HelpdeskReports, { SupportDashboard } from "../view/helpdesk/SupportReports.js";
import HelpdeskSettings from "../view/helpdesk/settings/index.js";
import ChatWidget from "../view/helpdesk/public/ChatWidget.js";
import CsatPage from "../view/helpdesk/public/CsatPage.js";
import Portal from "../view/helpdesk/public/Portal.js";
import PmProjects from "../view/pm/ProjectsHome.js";
import PmProject from "../view/pm/ProjectLayout.js";
import PmMyWork from "../view/pm/MyWork.js";
import PmWorkspaceView from "../view/pm/WorkspaceViews.js";
import PmReports from "../view/pm/PmReports.js";
import PmSettings from "../view/pm/PmSettings.js";
import PmDataImport from "../view/pm/DataImport.js";
import { Navigate } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/auth/idpass-login",
    element: <IdPassLogin />,
  },

  {
    path: "/get-started",
    element: <GetStarted />,
  },
  {
    path: "/lead-form/:userId",
    element: <LeadCaptureForm />,
  },
  {
    path: "/user/schedule-settings",
    element: <ProtectedRoute element={<ScheduleSettings />} />,
  },
  {
    path: "/appointment-booking",
    element: <ProtectedRoute element={<AppointmentBooking />} />,
  },
  {
    path: "/google-calendar-callback",
    element: <ProtectedRoute element={<GoogleCallback />} />,
  },
  {
    path: "/outlook-calendar-callback",
    element: <ProtectedRoute element={<OutlookCallback />} />,
  },
  {
    path: "/settings/calendar",
    element: <ProtectedRoute element={<CalendarSettings />} />,
  },
  {
    path: "/book",
    element: <BookingPage />,
  },
  {
    path: "/form",
    element: <ProtectedRoute element={<MultiStepForm />} />,
  },
  {
    path: "/call-type",
    element: <ProtectedRoute element={<CallType />} />,
  },
  {
    path: "/campaign/number",
    element: <ProtectedRoute element={<CampaignNumber />} />,
  },
  {
    path: "/number",
    element: <ProtectedRoute element={<Number />} />,
  },
  {
    path: "/loading",
    element: <ProtectedRoute element={<Loading />} />,
  },
  {
    path: "/faq-selection",
    element: <ProtectedRoute element={<OptionFaq />} />,
  },
  {
    path: "/campaign/faq-selection",
    element: <ProtectedRoute element={<CampaignOptionFaq />} />,
  },
  {
    path: "/campaign/select-industry-type",
    element: <ProtectedRoute element={<CampaignSelectIndustryType />} />,
  },
  {
    path: "/select-industry-type",
    element: <ProtectedRoute element={<SelectIndustryType />} />,
  },
  {
    path: "/campaign/manual-faq",
    element: <ProtectedRoute element={<CampaignManualFaq />} />,
  },
  {
    path: "/manual-faq",
    element: <ProtectedRoute element={<ManualFaq />} />,
  },
  {
    path: "/manual-faq-by-ai",
    element: <ProtectedRoute element={<ManualFaqByAi />} />,
  },
  {
    path: "/add-manual-faq-by-ai",
    element: <ProtectedRoute element={<ShowFaqByAi />} />,
  },
  {
    path: "/campaign/saas",
    element: <ProtectedRoute element={<CampaignSaaS />} />,
  },
  {
    path: "/saas",
    element: <ProtectedRoute element={<SaaS />} />,
  },
  {
    path: "/campaign/ECommerce",
    element: <ProtectedRoute element={<CampaignECommerce />} />,
  },

  {
    path: "/ECommerce",
    element: <ProtectedRoute element={<ECommerce />} />,
  },
  {
    path: "/campaign/Education",
    element: <ProtectedRoute element={<CampaignEducation />} />,
  },
  {
    path: "/Education",
    element: <ProtectedRoute element={<Education />} />,
  },
  {
    path: "/campaign/HealthCare",
    element: <ProtectedRoute element={<CampaignHealthCare />} />,
  },
  {
    path: "/campaign/other",
    element: <ProtectedRoute element={<CampaignOther />} />,
  },
  {
    path: "/HealthCare",
    element: <ProtectedRoute element={<HealthCare />} />,
  },
  {
    path: "/campaign/software",
    element: <ProtectedRoute element={<CampaignSoftware />} />,
  },
  {
    path: "/Software",
    element: <ProtectedRoute element={<Software />} />,
  },
  {
    path: "/campaign/startup",
    element: <ProtectedRoute element={<CampaignStartup />} />,
  },
  {
    path: "/Startup",
    element: <ProtectedRoute element={<Startup />} />,
  },
  {
    path: "/campaign/telecommunications",
    element: <ProtectedRoute element={<CampaignTelecommunications />} />,
  },
  {
    path: "/Telecommunications",
    element: <ProtectedRoute element={<Telecommunications />} />,
  },
  {
    path: "/campaign/Travel",
    element: <ProtectedRoute element={<CampaignTravel />} />,
  },
  {
    path: "/Travel",
    element: <ProtectedRoute element={<Travel />} />,
  },

  {
    path: "/Other",
    element: <ProtectedRoute element={<Other />} />,
  },
  {
    path: "/qr",
    element: <ProtectedRoute element={<Qr />} />,
  },
  {
    path: "/dashboard-v2",
    element: <ProtectedRoute element={<DashBoard />} />,
  },
  {
    path: "/dashboard",
    element: <ProtectedRoute element={<DashboardV2 />} />,
  },
  {
    path: "/agent/dashboard",
    element: <ProtectedRoute element={<AgentDashBoard />} />,
  },

  {
    path: "/faq",
    element: <ProtectedRoute element={<Faq />} />,
  },
  {
    path: "/Pricing",
    element: <ProtectedRoute element={<PricingPlans />} />,
  },
  {
    path: "/bill-details/:id",
    element: <ProtectedRoute element={<BillDetails />} />,
  },
  {
    path: "/checkout/",
    element: <ProtectedRoute element={<CheckOut />} />,
  },
  {
    path: "/checkout/:id",
    element: <ProtectedRoute element={<ChashfreeRes />} />,
  },
  {
    path: "/Call-Log",
    element: <ProtectedRoute element={<CallLogs />} />,
  },
  {
    path: "/all-tickets",
    element: <ProtectedRoute element={<TicketTable />} />,
  },
  {
    path: "/single-ticket:id",
    element: <ProtectedRoute element={<SingleTicket />} />,
  },
  {
    path: "/single-ticket/:id",
    element: <ProtectedRoute element={<SingleTicket />} />,
  },
  {
    path: "/profile",
    element: <ProtectedRoute element={<Profile />} />,
  },
  {
    path: "/Integrations",
    element: <ProtectedRoute element={<Integrations />} />,
  },
  {
    path: "/lead-management-system",
    element: <ProtectedRoute element={<Kanban />} />,
  },
  {
    path: "/lead-management-system/:id",
    element: <ProtectedRoute element={<EditLeads />} />,
  },
  {
    path: "/new-lead",
    element: <ProtectedRoute element={<NewLead />} />,
  },
  {
    path: "/reports/sla",
    element: <ProtectedRoute element={<Sla />} />,
  },
  {
    path: "/reports/conversion",
    element: <ProtectedRoute element={<ConversionReport />} />,
  },
  {
    path: "/reports/cdr",
    element: <ProtectedRoute element={<CDRReport />} />,
  },
  {
    path: "/reports/traffic",
    element: <ProtectedRoute element={<TrafficReport />} />,
  },
  {
    path: "/reports/unreached",
    element: <ProtectedRoute element={<UnreachedLeadsReport />} />,
  },
  {
    path: "/team-members",
    element: <ProtectedRoute element={<TeamMembers />} />,
  },

  //// complaint management
  {
    path: "/complaints",
    element: <ProtectedRoute element={<Complaints />} />,
  },
  {
    path: "/complaints/reports",
    element: <ProtectedRoute element={<ComplaintReports />} />,
  },
  {
    path: "/complaints/settings",
    element: <ProtectedRoute element={<ComplaintSettings />} />,
  },
  {
    path: "/complaints/:id",
    element: <ProtectedRoute element={<ComplaintDetail />} />,
  },

  //// helpdesk (support)
  { path: "/helpdesk", element: <Navigate to="/helpdesk/tickets" replace /> },
  { path: "/helpdesk/tickets", element: <ProtectedRoute element={<HelpdeskInbox />} /> },
  { path: "/helpdesk/tickets/:id", element: <ProtectedRoute element={<HelpdeskTicket />} /> },
  { path: "/helpdesk/chat", element: <ProtectedRoute element={<HelpdeskChat />} /> },
  { path: "/helpdesk/customers/:contactId", element: <ProtectedRoute element={<HelpdeskCustomer />} /> },
  { path: "/helpdesk/kb", element: <ProtectedRoute element={<HelpdeskKnowledge />} /> },
  { path: "/helpdesk/dashboard", element: <ProtectedRoute element={<SupportDashboard />} /> },
  { path: "/helpdesk/reports", element: <ProtectedRoute element={<HelpdeskReports initial="tickets" />} /> },
  { path: "/helpdesk/settings", element: <ProtectedRoute element={<HelpdeskSettings />} /> },
  // project management
  { path: "/projects", element: <ProtectedRoute element={<PmProjects />} /> },
  { path: "/projects/:key", element: <ProtectedRoute element={<PmProject />} /> },
  { path: "/projects/:key/issues/:issueKey", element: <ProtectedRoute element={<PmProject />} /> },
  { path: "/projects/:key/boards/:boardId", element: <ProtectedRoute element={<PmProject />} /> },
  { path: "/projects/:key/boards/:boardId/:view", element: <ProtectedRoute element={<PmProject />} /> },
  { path: "/projects/:key/:tab", element: <ProtectedRoute element={<PmProject />} /> },
  { path: "/pm", element: <Navigate to="/pm/my-work" replace /> },
  { path: "/pm/my-work", element: <ProtectedRoute element={<PmMyWork />} /> },
  { path: "/pm/issues", element: <ProtectedRoute element={<PmMyWork mode="issues" />} /> },
  { path: "/pm/backlog", element: <ProtectedRoute element={<PmWorkspaceView kind="backlog" />} /> },
  { path: "/pm/sprints", element: <ProtectedRoute element={<PmWorkspaceView kind="sprints" />} /> },
  { path: "/pm/boards", element: <ProtectedRoute element={<PmWorkspaceView kind="boards" />} /> },
  { path: "/pm/releases", element: <ProtectedRoute element={<PmWorkspaceView kind="releases" />} /> },
  { path: "/pm/roadmaps", element: <ProtectedRoute element={<PmWorkspaceView kind="roadmaps" />} /> },
  { path: "/pm/reports", element: <ProtectedRoute element={<PmReports mode="reports" />} /> },
  { path: "/pm/dashboards", element: <ProtectedRoute element={<PmReports mode="dashboards" />} /> },
  { path: "/pm/dashboards/:id", element: <ProtectedRoute element={<PmReports mode="dashboards" />} /> },
  { path: "/pm/settings", element: <ProtectedRoute element={<PmSettings />} /> },
  { path: "/pm/import", element: <ProtectedRoute element={<PmDataImport />} /> },
  // customer-facing, no login
  { path: "/widget/:widgetKey", element: <ChatWidget /> },
  { path: "/csat/:token", element: <CsatPage /> },
  // public customer portal (help centre, web form, my tickets, guest tracking, independent auth)
  { path: "/support/:slug", element: <Portal page="home" /> },
  { path: "/support/:slug/articles/:articleId", element: <Portal page="article" /> },
  { path: "/support/:slug/new", element: <Portal page="new" /> },
  { path: "/support/:slug/tickets", element: <Portal page="tickets" /> },
  { path: "/support/:slug/my-tickets", element: <Portal page="tickets" /> },
  { path: "/support/:slug/tickets/:key", element: <Portal page="ticket" /> },
  { path: "/support/:slug/tickets/guest/:token", element: <Portal page="guest-ticket" /> },
  { path: "/support/ticket/:token", element: <Portal page="guest-ticket-direct" /> },
  { path: "/support/:slug/auth", element: <Portal page="auth" /> },
  { path: "/support/:slug/login", element: <Portal page="login" /> },
  { path: "/support/:slug/register", element: <Portal page="register" /> },
  { path: "/support/:slug/forgot-password", element: <Portal page="forgot-password" /> },
  { path: "/support/:slug/reset-password", element: <Portal page="reset-password" /> },
  { path: "/support", element: <Portal page="home" /> },
  { path: "/support/new-ticket", element: <Portal page="new" /> },
  {
    path: "/MetaLeads",
    element: <ProtectedRoute element={<MetaLeads />} />,
  },

  //// agnet routes
  {
    path: "/agent/login",
    element: <AgentLogin />,
  },
  {
    path: "/agent/all-ticket",
    element: <ProtectedRoute element={<AgentTickets />} />,
  },
  {
    path: "/agent/tickets/:id",
    element: <ProtectedRoute element={<SIngleTicket />} />,
  },
  {
    path: "/user/tickets/:id",
    element: <ProtectedRoute element={<UserSIngleTicket />} />,
  },
  {
    path: "/agent/attendance",
    element: <ProtectedRoute element={<AgentAttendance />} />,
  },
  {
    path: "/agent/campaign-sync",
    element: <ProtectedRoute element={<CampaignSyncView />} />,
  },
  {
    path: "/agent/campaign-monitor",
    element: <ProtectedRoute element={<CampaignMonitorView />} />,
  },
  /// admin routes
  {
    path: "/admin/overview",
    element: <ProtectedRoute element={<AdminDashboard />} />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/all-leads",
    element: <ProtectedRoute element={<AdminLeads />} />,
  },
  {
    path: "/admin/single-lead/:id",
    element: <ProtectedRoute element={<SingleLead />} />,
  },
  {
    path: "/admin/users",
    element: <ProtectedRoute element={<AllUsers />} />,
  },
  {
    path: "/admin/dids",
    element: <ProtectedRoute element={<Did />} />,
  },
  {
    path: "/admin/drop-off",
    element: <ProtectedRoute element={<DropOff />} />,
  },
  {
    path: "/admin/revenue/:id",
    element: <Revenue />,
  },
  {
    path: "/admin/revenue-analytics",
    element: <ProtectedRoute element={<RevenueAnalytics />} />,
  },
  {
    path: "/admin/edit-user/:id",
    element: <ProtectedRoute element={<EditUser />} />,
  },
  {
    path: "/admin/add-team-member/:id",
    element: <ProtectedRoute element={<TeamMember />} />,
  },
  {
    path: "/admin/details",
    element: <ProtectedRoute element={<DetailsModule />} />,
  },
  {
    path: "/admin/details/:clientId",
    element: <ProtectedRoute element={<ClientLogsIndex />} />,
  },
  {
    path: "/admin/agents",
    element: <ProtectedRoute element={<AdminAgents />} />,
  },
  {
    path: "/admin/history",
    element: <ProtectedRoute element={<HistoryModule />} />,
  },
  {
    path: "/admin/sidebar-settings",
    element: <ProtectedRoute element={<SidebarSettings />} />,
  },
  {
    path: "/otp",
    element: <Otp />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  ///////landing page
  {
    path: "/landing-page",
    element: <LandingPage />,
  },
  {
    path: "/built-for-you",
    element: <BuiltForYou />,
  },
]);

export default router;
